<template>
  <div>
    <search-esim @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <span slot="eid" slot-scope="text, record">
        <a @click="showDetail(record)">{{ text }}</a>
      </span>
      <span slot="actions" slot-scope="text, record">
        <a @click="showDownloadModal(record)">下载 Profile</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <download-profile
      v-if="isShowDownloadModal"
      :visible.sync="isShowDownloadModal"
      :esim-id="currentEsimId"
      :eid="currentEid"
      :agent-id="agentId"
      @completed="fetchData"
    />

    <show-esim
      v-if="isShowDetailModal"
      :visible.sync="isShowDetailModal"
      :id="currentEsimId"
    />
  </div>
</template>

<script>
import { findEsims } from '@/api/esim'
import Pagination from '@/components/Pagination'
import SearchEsim from '@/views/esims/Search'

export default {
  name: 'EsimList',
  components: {
    Pagination,
    SearchEsim,
    DownloadProfile: () => import('@/views/esims/DownloadProfile'),
    ShowEsim: () => import('@/views/esims/Show')
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      isShowDownloadModal: false,
      isShowDetailModal: false,
      currentEsimId: 0,
      currentEid: '',
      columns: [
        {
          title: 'EID',
          dataIndex: 'eid',
          width: 320,
          fixed: 'left',
          scopedSlots: { customRender: 'eid' }
        },
        {
          title: '产品名称',
          dataIndex: 'product_name',
          width: 160
        },
        {
          title: '在线状态',
          dataIndex: 'eim_online_status_name',
          width: 100
        },
        {
          title: '支持协议',
          dataIndex: 'eim_support_protocol_name',
          width: 100
        },
        {
          title: '关联 Profile 数量',
          dataIndex: 'linked_profile_count',
          width: 140
        },
        {
          title: '更新时间',
          dataIndex: 'eim_data_updated_at',
          width: 170
        },
        {
          title: '卡片材质',
          dataIndex: 'card_type_name',
          width: 120
        },
        {
          title: '卡片尺寸',
          dataIndex: 'card_shape_name',
          width: 120
        },
        {
          title: '订单编号',
          dataIndex: 'order_no',
          width: 160
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '操作',
          dataIndex: 'actions',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  computed: {
    agentId() {
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findEsims(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    showDownloadModal(record) {
      this.currentEsimId = record.id
      this.currentEid = record.eid
      this.isShowDownloadModal = true
    },
    showDetail(record) {
      this.currentEsimId = record.id
      this.currentEid = record.eid
      this.isShowDetailModal = true
    }
  }
}
</script>
